module.exports = __webpack_public_path__ + "img/流体力学1_3_4.68cca8e2.jpg";